import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import treeSearch from "../images/icon_home_search.png";
import treeViewCollapse from "../../assets/svg/Tree_view_collapse.svg";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import {
  createPkgsAct,
  createTagsAct,
  createTTAct,
  switchCategoryTags,
  switchInsTypeTags,
  switchPkgTags,
  switchTagPkgAct,
  switchTagTTAct,
  switchTTTagAct,
} from "../redux/project/projActions";
import "./configDetTagTree.scss";
import { showLoader, assignTags } from "../redux/ctrl/ctrlActions";
// import {TiTick,TiCancel} from 'react-icons/ti';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { TreeView } from "@mui/x-tree-view";
import {
  createPrjAsn,
  fetchPrjAsn,
  updatePrjAsn,
} from "../redux/prjasn/prjAsnActions";
import { VscCollapseAll, VscExpandAll } from "react-icons/vsc";
import {
  MdAdd,
  MdClear,
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdAddCircleOutline,
  MdClose,
} from "react-icons/md";
import CustomTreeItem from "./TreeItem";
import { fmodelbreakAct } from "../redux/project/projActions";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { useLocation } from "react-router-dom";
import { fModelBreakMulAct } from "../redux/project/projActions";
import { IconButton } from "@mui/material";
import { FaAnglesLeft } from "react-icons/fa6";
import COLORS from "../styles/COLORS";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    //  cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const ConfigDetTagTree = (props) => {
  // console.log("location.configDettree.name",location.state.data);
  // const select=location.state.data
  // console.log("select",select)

  const { slctRev, configFilter } = props;
  // console.log(" configFilter ", configFilter)
  const dispatch = useDispatch();
  const [gridApi, setGridApi] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);

  const [searchtag, setSearchTag] = useState("");
  const profile = useSelector((state) => state.profile);
  const ctrlState = useSelector((state) => state.ctrl);
  // console.log('ctrlState',ctrlState);
  const conf_stat = ctrlState?.tags?.config_status;
  // console.log('conf_stat',conf_stat);
  // const proj = useSelector((state) => state.ctrl.data)
  // let techTyps = useSelector((state) => state.ctrl.techTypes);
  const pkg = useSelector((state) => state.ctrl.pkg);
  const uptag = useSelector((state) => state.prjasn.projectsAsn);
  const techTypsLkp = useSelector((state) => state.ctrl.techTypes);
  const techTyps = useSelector((state) => state.project.techTyps);
  const tags = useSelector((state) => state.project.tags);
  const selectedTag = useSelector((state) => state.ctrl.tags);
  const modelBreak = useSelector((state) => state?.project?.getModelBreak);
  const { t, i18n } = useTranslation();
  const active_revision = useSelector(
    (state) => state.ctrl.pkg.active_revision
  );
  const { showProgressBar } = useSelector((state) => state.project);
  // const getTags = useSelector((state) => state.project.tags).filter(i=>i?.config_status.split("-")[0]=="VALID")
  const getTags = useSelector((state) => state.project.tags).filter(
    (i) =>
      i?.config_status?.split("-")[0] !== "UNCONFIG" &&
      i?.configuration_import === "SUCCESS"
  );

  //console.log("getTags1", getTags);
  //console.log("selected tag", selectedTag);
  // selectedTag.forEach(tag => {
  //   console.log("tagnumber", tag.tag_number);
  // });

  const crTagCap =
    profile.capb.findIndex((o) => o.PWSCRTAG === "Y") >= 0 ? false : true;
  const updTagCap =
    profile.capb.findIndex((o) => o.PWSUPTAG === "Y") >= 0 ? false : true;
  const [tagId, setTagId] = useState("");
  const [modelData, setModelData] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState("");
  //----search------

  const handleSearchInput = (e) => {
    e.preventDefault();
    setSearchTag(e.target.value);
    props.setFindTag(e.target.value);
  };
  // const [hidePkgs, setHidePkgs] = useState([]);
  // const [hideCtgrs, setHideCtgrs] = useState([])
  // const [hiddenTagPkgs, setHiddenTagPkgs] = useState([]);
  let fPkg = useSelector((state) => state.ctrl.pkg);
  let pkgs1 = useSelector((state) =>
    state.project.packages.filter((o) =>
      o.project_id === fPkg.project_id && o.package_id === fPkg.package_id
    )
  );
  const gtechTyps = useSelector((state) => state.project.techTyps);

  // const profile = useSelector((state) => state.profile);
  const [state, setState] = useState({
    ttList: [],
    showTT: true,
    selectedTT: [],
  });
  let pkgs = [...pkgs1];

  let tempCardNodes = [];
  techTypsLkp.forEach((i) => {
    tempCardNodes.push(i.category);
    tempCardNodes.push(i.instrumentType);
  });
  const [cardNodes, setCardNodes] = useState(tempCardNodes);
  const [treeNodes, setTreeNodes] = useState([]);
  const [tagState, setTagState] = useState({
    showPkg: false,
    message: "",
    refresh: false,
  });
  const [selectedTreeTag, setSelectedTreeTag] = useState("");

  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === 'Instrumentation' ? true : false;
  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);


  // const sideBarRef = React.useRef(null);
  let chkCatNode = [];

  let pl = null;
  useEffect(() => {
    setState({
      ttList: [], // const dispatch = useDispatch();

      showTT: true,
      selectedTT: [],
    });
  }, [slctRev]);

  useEffect(() => {
    // dispatch(fetchPrjAsn());
  }, []);

  useEffect(() => {
    if (modelBreak) {
      //console.log("configdetailtegtree", { modelBreak });
      setModelData(modelBreak);
      //setModelData(data1);
    }
    //dispatch(showLoader(true));
  }, [modelBreak]);

  const [writeAcc, setWriteAcc] = useState();

  useEffect(() => {
    let write_accs = uptag.filter(
      (item) =>
        item.project_id === ctrlState.data?.project_id &&
        profile.email === item.email_id
    )[0]?.write_access;
    write_accs =
      ctrlState.data.created_by == profile.email || write_accs == "Y"
        ? true
        : false;
    setWriteAcc(write_accs);
  }, [uptag, ctrlState.data]);

  // let tempttListCat = state.ttList.length > 0 ? state.ttList.map(i => i.category) : []
  // let ttListCat = [...new Set(tempttListCat)]

  const getUnique = (array) => {
    return [...new Set(array)];
  };

  const sortAlphaNum = (a, b) => b?.localeCompare(a, "en", { numeric: true });
  const sortAlphaNumTag = (a, b) =>
    a.tag_number?.localeCompare(b.tag_number, "en", { numeric: true });

  const expandAllTree = () => {
    let tempTreeNodes = []
    let count = 0
    chkCatNode = []
    if (techTyps.length == 0) {
      setTreeNodes([pkg.package_id] + "")
    }
    techTyps.forEach((i, index, array) => {
      tempTreeNodes.push(i.technology_name, i.instrument_type, (i.technology_id).toString())
      // tempTreeNodes.push(i.technology_name, i.instrument_type)
      chkCatNode.push(i.technology_name)
      count++;
      if (count === array.length) {
        let tempArr = getUnique(tempTreeNodes)
        setTreeNodes([pkg.package_id + "", ...tempArr])
      }
    })
  }


  useEffect(() => {
    expandAllTree();
  }, [techTyps.length]);

  // const toggleSelection = (e) => {
  //   const tagId = e.target.getAttribute("data-identifier").split('~')[1];
  //   const filteredTag = getTags.find(tag => tag.tag_id == tagId);

  //    console.log("filteredTag",filteredTag)
  //   e.stopPropagation()
  //   const nodeType = e.target.getAttribute("data-type")
  //   const isSelected = e.target.checked;
  //   const package_id = pkg.package_id;
  //   if (nodeType === 'PKG') {
  //     pl = {
  //       package_id: e.target.getAttribute("data-identifier"),
  //       selected: e.target.checked
  //     }
  //     dispatch(switchPkgTags(pl))``
  //   }
  //   else if (nodeType === 'TN') {
  //     pl = {
  //       package_id: pkg.package_id,
  //       category: e.target.getAttribute("data-identifier"),
  //       // technology_ids: techTyps.filter(i => i.technology_name == e.target.getAttribute("data-identifier")).map(o => o.technology_id),
  //       selected: e.target.checked
  //     }
  //     dispatch(switchCategoryTags(pl))

  //   }
  //   else if (nodeType === 'IT') {
  //     pl = {
  //       package_id: pkg.package_id,
  //       instrumentType: e.target.getAttribute("data-identifier"),
  //       // technology_ids: techTyps.filter(i => i.instrument_type == e.target.getAttribute("data-identifier")).map(o => o.technology_id),
  //       selected: e.target.checked
  //     }
  //     dispatch(switchInsTypeTags(pl))
  //   }
  //   else if (nodeType === 'PD') {
  //     pl = {
  //       package_id: pkg.package_id,
  //       technology_id: e.target.getAttribute("data-identifier"),
  //       selected: e.target.checked
  //     }
  //     dispatch(switchTTTagAct(pl))
  //   }
  //  else if (nodeType === 'TAG') {
  //     pl = {
  //       package_id: pkg.package_id,
  //       technology_id: e.target.getAttribute("data-identifier").split('~')[0],
  //       //tag_id: e.target.getAttribute("data-identifier").split('~')[1],
  //       filteredTag : filteredTag,
  //       selected: e.target.checked
  //     }
  //     //dispatch(switchTagTTAct(pl))
  //    // dispatch(showLoader(true));
  //     dispatch(assignTags(filteredTag))
  //     //console.log(ctrlState,"ctrlState")
  //     // console.log(filteredTag,"filteredTag111")

  //     dispatch(
  //       fmodelbreakAct({
  //         p_application: "PRJWS",
  //         p_technology_name:filteredTag.gen_technology_type,
  //         p_tag_id: filteredTag.tag_id,
  //       })
  //     );

  //   }
  // }
  function filterUniqueModels1(modelData) {
    if (Array.isArray(modelData)) {
      const uniqueModels = modelData.reduce((acc, current) => {

        const found = acc.some((group) => {
          for (let i = 1; i <= 6; i++) {


            if (group[`pur_mod_num_part${i}`] !== current[`pur_mod_num_part${i}`]) {
              return false;
            }
          }
          return true;
        });

        if (!found) {
          acc.push(current);
        }
        return acc;
      }, []);
      return uniqueModels;
    } else {
      return [];
    }
  }

  const toggleSelection = (e, tag, consTags) => {
    // console.log("111", e, tag);
    const tagId = tag.tag_id;
    const nodeType = e.target.getAttribute("data-type");
    const isSelected = e.target.checked;
    const package_id = pkg.package_id;
    //console.log("filteredTag", tag);
    e.stopPropagation();
    let pl;

    if (nodeType === "PKG") {
      pl = {
        package_id: e.target.getAttribute("data-identifier"),
        selected: isSelected,
      };
      dispatch(switchPkgTags(pl));
    } else if (nodeType === "TN") {
      pl = {
        package_id: pkg.package_id,
        category: e.target.getAttribute("data-identifier"),
        selected: isSelected,
      };
      dispatch(switchCategoryTags(pl));
    } else if (nodeType === "IT") {
      pl = {
        package_id: pkg.package_id,
        instrumentType: e.target.getAttribute("data-identifier"),
        selected: isSelected,
      };
      dispatch(switchInsTypeTags(pl));
    } else if (nodeType === "PD") {
      pl = {
        package_id: pkg.package_id,
        technology_id: e.target.getAttribute("data-identifier"),
        selected: isSelected,
      };
      dispatch(switchTTTagAct(pl));
    } else if (nodeType === "TAG") {
      consTags.forEach((o, index) => {
        // console.log(
        //   "1111",
        //   o.tag_id === tag.tag_id,
        //   consTags,
        //   tag,
        //   nodeType,
        //   selectedTag
        // );
        if (o.tag_id === tag.tag_id) {
          pl = {
            package_id: pkg.package_id,
            technology_id: e.target
              .getAttribute("data-identifier")
              ?.split("~")[0],
            filteredTag: tag,
            selected: isSelected,
          };
          const selectTags = selectedTag;
          if (isSelected) {
            selectTags.push(tag);
          } else {
            selectTags.forEach((e, index) => {
              if (tag.tag_id === e.tag_id) {
                selectTags.splice(index, 1);
              }
            });
          }
          dispatch(assignTags(selectTags));
          //dispatch(showLoader(true));

          const payload = {};
          if (selectTags.length > 0) {
            const PTechNameSet = new Set(); // Create a Set to hold unique values
            const PTagIds = [];
            const uniqueTags = isInstrumentationTab ? filterUniqueModels1(selectTags) : selectTags
            uniqueTags.forEach((tag) => {
              // PTechNameSet.add(tag.gen_technology_type); // Add each technology name to the Set
              // PTagIds.push(tag.tag_id);
              if (!payload[tag.gen_technology_type]) {
                payload[tag.gen_technology_type] = [];
              }
              payload[tag.gen_technology_type].push(tag.tag_id);
            });

            const PTechName = Array.from(PTechNameSet); // Convert the Set back to an array

            // dispatch(
            //   fModelBreakMultiAct({
            //     p_application: "PRJWS",
            //     p_technology_names: PTechName,
            //     p_tag_ids: PTagIds,
            //   })
            // );
            dispatch(fModelBreakMulAct(payload));
          }
          else {
            dispatch(fModelBreakMulAct({}));
          }

        }
      });
    }
  };

  const onSelectedTT = (e) => {
    let isValueChecked = e.target.checked;
    let temp = [];
    temp = state.selectedTT;
    if (isValueChecked) {
      temp.push({ ttId: e.target.value });
      setState((prevState) => {
        return { ...prevState, selectedTT: temp };
      });
    } else {
      var index = state.selectedTT.findIndex((o) => o.ttId === e.target.value);
      if (index > -1) {
        temp.splice(index, 1);
        setState((prevState) => {
          return { ...prevState, selectedTT: temp };
        });
      }
    }
  };

  const onSelectedInsTyp = (e) => {
    e.stopPropagation();
    let isValueChecked = e.target.checked;
    state.ttList
      .filter((i) => i.instrumentType == e.target.value)
      .forEach((i) => {
        onSelectedTT({
          target: { checked: isValueChecked, value: i.lookup_code },
        });
      });
  };
  const onSelectedCat = (e) => {
    e.stopPropagation();
    let isValueChecked = e.target.checked;
    state.ttList
      .filter((i) => i.category == e.target.value)
      .forEach((i) => {
        onSelectedTT({
          target: { checked: isValueChecked, value: i.lookup_code },
        });
      });
  };
  const getTagData = (e) => {
    // console.log(e.target.textContent);
    e.stopPropagation();
    const tag = getTags.find((ele) => e.target.textContent === ele.tag_number);

    props.setSelectedTag(tag);
    setSelectedTreeTag(tag.tag_number);
  };

  // console.log("selectedTreeTag",selectedTreeTag)
  // const techTypeTree = () => {
  //   return getUnique(techTyps.map(i => i.technology_name)).map((cat, index) => {
  //     // let tt = cTechTyps(project_id, package_id, cat)
  //     let insTyps = cInsTyps(cat)
  //     let chk = techTyps.some(tt => tt.technology_name == cat && tt.selected == 'Y')

  //     return (
  //       <CustomTreeItem key={cat} nodeId={cat}
  //         label={
  //           // <FormControlLabel control={<CustomCheckbox checked={chk} inputProps={{
  //           //   'data-type': 'TN',
  //           //   'data-identifier': cat
  //           // }}
  //           //   onClick={e => toggleSelection(e)} />} label={cat} />
  //           <label className='treeLabel' >
  //             <input className='treeCheckbox' type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={chk} data-type='TN' data-identifier={cat} />
  //             <span className='MuiFormControlLabel-label' onClick={(e) => e.stopPropagation()} >{cat}</span>
  //           </label>
  //         }
  //       >
  //         {insTyps}
  //       </CustomTreeItem>
  //     )

  //   })
  // }
  const techTypeTree = () => {
    return getUnique(techTyps.map((i) => i.technology_name))
      .filter(i => isInstrumentationTab && !commercialTypes.includes(i)).map(
        (cat, index) => {
          let insTyps = cInsTyps(cat);
          let chk = techTyps.some(
            (tt) => tt.technology_name === cat && tt.selected === "Y"
          );

          return (
            <CustomTreeItem
              key={cat}
              nodeId={cat}
              label={
                <label className="treeLabel">
                  {/* <input
                className='treeCheckbox'
                type='checkbox'
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => toggleSelection(e)}
                checked={chk}
                data-type='TN'
                data-identifier={cat}
              /> */}
                  <span
                    className="MuiFormControlLabel-label mr-0"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {cat}
                  </span>
                </label>
              }
            >
              {insTyps}
            </CustomTreeItem>
          );
        }
      );
  };

  const commTypeTree = () => {
    const commTypes = techTyps
      .filter((i) => i.technology_name === wsTabValue)
      .map((type) => {
        const pd = prodDesc(type.instrument_type, type.technology_name);
        return pd;
      });
    return commTypes;
  }

  const cInsTyps = (cat) => {
    let gInsTyps = getUnique(
      techTyps
        .filter((i) => i.technology_name == cat)
        .map((i) => i.instrument_type)
    );
    let insTypItem = gInsTyps.map((itype) => {
      let pD = prodDesc(itype, cat);
      let chk1 = techTyps.some(
        (tt) => tt.instrument_type == itype && tt.selected == "Y"
      );

      return (
        <CustomTreeItem
          key={itype}
          nodeId={itype}
          label={
            <label className="treeLabel">
              {/* <input className='treeCheckbox'
               type='checkbox' 
               onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={chk1} data-type='IT' data-identifier={itype} /> */}
              <span
                onClick={(e) => e.stopPropagation()}
                className="MuiFormControlLabel-label mr-0"
              >
                {itype}
              </span>
            </label>
          }
        >
          {pD}
        </CustomTreeItem>
      );
    });
    return insTypItem;
  };
  // const cInsTyps = (cat) => {
  //   // Filter out instrument types without tags
  //   let gInsTyps = getUnique(
  //     techTyps.filter(i => i.technology_name === cat)
  //       .filter(i => {
  //         const tagsForInstrumentType = getTags.filter(tag => tag.gen_instrument_type === i.instrument_type);
  //         return tagsForInstrumentType.length > 0;
  //       })
  //       .map(i => i.instrument_type)
  //   );

  //   let insTypItem = gInsTyps.map((itype) => {
  //     let pD = prodDesc(itype, cat);
  //     let chk1 = techTyps.some(tt => tt.instrument_type === itype && tt.selected === 'Y');

  //     return (
  //       <CustomTreeItem key={itype} nodeId={itype}
  //         label={
  //           <label className='treeLabel'>
  //             <span onClick={(e) => e.stopPropagation()} className='MuiFormControlLabel-label mr-0'>{itype}</span>
  //           </label>
  //         }
  //       >
  //         {pD}
  //       </CustomTreeItem>
  //     );
  //   });

  //   return insTypItem;
  // };

  const prodDesc = (itype, cat) => {
    // let itemTTyps = null;
    let ftechTyps = techTyps.filter((i) => i.instrument_type == itype);
    let consTechTypes = ftechTyps.map((ttype, index) => {
      let ttItem = null;
      // !showProgressBar &&
      let tag = !showProgressBar && state.showTT && ctags(itype, ttype, cat);
      ttItem = (
        <CustomTreeItem
          key={ttype.technology_id}
          nodeId={ttype.technology_id.toString()}
          label={
            <label className="treeLabel">
              {/* <input className='treeCheckbox' type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={ttype.selected == 'Y' ? true : false} data-type='PD' data-identifier={ttype.technology_id} /> */}
              <span
                className="MuiFormControlLabel-label mr-0"
                onClick={(e) => e.stopPropagation()}
              >
                {ttype?.product_description}
              </span>
            </label>

            // </StyledTooltip>
          }
        >
          {tag}
        </CustomTreeItem>
      );
      return ttItem;
    });
    return consTechTypes;
  };

  // const ctags = (itype, ttype, cat) => {
  //   let itemTags = null;
  //   let fetchTags = treeNodes.includes((ttype.technology_id).toString()) && getTags.filter(i => i.gen_instrument_type === itype && i.gen_prod_desc === ttype.product_description)
  //   let consTags = null

  //   consTags = treeNodes.includes((ttype.technology_id).toString()) && fetchTags.sort(sortAlphaNumTag).map((o, index) => {
  //     let tagItem = null;
  //     tagItem = (
  //       <React.Fragment key={o.tag_number}>
  //         <div style={{ marginLeft: '15px' }} hidden={!state.showTT} >
  //           <label style={{ background: o.tag_number === selectedTag?.tag_number, cursor: "pointer" }} className='treeLabel'>
  //             <input
  //               className='treeCheckbox'
  //               type='checkbox'
  //               onChange={e => toggleSelection(e)}
  //               //onChange={e => toggleSelection(e, o.tag_number)}
  //               checked={o.tag_number === selectedTag?.tag_number}
  //               //checked={selectedTags.some(tag => tag.tag_number === o.tag_number)}

  //              // checked={o.selected == 'Y' ? true : false}
  //               data-type='TAG'
  //               data-identifier={ttype.technology_id + '~' + o.tag_id}
  //             />
  //             <span className='MuiFormControlLabel-label' onClick={getTagData} >{o.tag_number}</span>
  //           </label>
  //         </div>
  //       </React.Fragment>
  //     );
  //     return tagItem;
  //   });

  //   itemTags = (
  //     <React.Fragment>
  //       {consTags}
  //     </React.Fragment>
  //   );
  //   return itemTags;
  // };

  const ctags = (itype, ttype, cat) => {
    let itemTags = null;
    let fetchTags =
      treeNodes.includes(ttype.technology_id.toString()) &&
      getTags.filter(
        (i) =>
          i.gen_instrument_type === itype &&
          i.gen_prod_desc === ttype.product_description
      );
    let consTags = null;
    //console.log({ fetchTags });
    consTags =
      treeNodes.includes(ttype.technology_id.toString()) &&
      fetchTags.sort(sortAlphaNumTag).map((o, index) => {
        let tagItem = null;
        // console.log(
        //   "Hiii",
        //   selectedTag.some((tag) => tag.tag_number === o.tag_number)
        // );

        tagItem = (
          <React.Fragment key={o.tag_number}>
            <div style={{ marginLeft: "15px" }} hidden={!state.showTT}>
              <label
                style={{
                  background: o.tag_number === selectedTag?.tag_number,
                  cursor: "pointer",
                }}
                className="treeLabel"
              >
                <input
                  className="treeCheckbox"
                  type="checkbox"
                  onChange={(e) => toggleSelection(e, o, fetchTags)}
                  checked={selectedTag.some(
                    (tag) => tag.tag_number === o.tag_number
                  )}
                  data-type="TAG"
                  data-identifier={ttype.technology_id + "~" + o.tag_id}
                />
                <span
                  className="MuiFormControlLabel-label"
                  onClick={getTagData}
                >
                  {o.tag_number}
                </span>
              </label>
            </div>
          </React.Fragment>
        );
        return tagItem;
      });
    //console.log({ consTags });
    itemTags = <React.Fragment>{consTags}</React.Fragment>;

    return itemTags;
  };

  let packages;

  packages = pkgs.map((currpkg, index) => {
    let item = null;
    let techTyps = isInstrumentationTab ? techTypeTree() : commTypeTree();
    item = (
      <React.Fragment key={"P" + index}>
        {!state.showTT}
        <TreeView
          style={{ width: "90%" }}
          expanded={[...treeNodes]}
          onNodeToggle={(e, id) => setTreeNodes(id)}
          defaultCollapseIcon={<MdKeyboardArrowDown style={{ color: COLORS.green }} />}
          defaultExpandIcon={<MdKeyboardArrowRight style={{ color: COLORS.green }} />}
        >
          <CustomTreeItem
            nodeId={pkg.package_id + ""}
            label={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label className="treeLabel">
                  {/* <input className='treeCheckbox' type='checkbox' onClick={(e) => e.stopPropagation()} onChange={e => toggleSelection(e)} checked={pkg.selected == 'Y' ? true : false} data-type='PKG' data-identifier={pkg.package_id} /> */}
                  <span
                    className="MuiFormControlLabel-label mr-0"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {pkg.package_name}
                  </span>
                </label>
                {!treeNodes.includes("DP Flow") &&
                  !treeNodes.includes("DP Level") &&
                  !treeNodes.includes("Flow") &&
                  treeNodes.includes(pkg.package_id + "") ? (
                  <VscExpandAll
                    style={{
                      color: COLORS.green,
                      marginRight: "5px",
                      fontSize: "18px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      expandAllTree();
                    }}
                  />
                ) : treeNodes.includes(pkg.package_id + "") ? (
                  <VscCollapseAll
                    style={{
                      color: COLORS.green,
                      marginRight: "5px",
                      fontSize: "18px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setTreeNodes([pkg.package_id + ""])
                    }}
                  />
                ) : null}
              </div>
            }
          >
            {techTyps}
          </CustomTreeItem>
        </TreeView>
      </React.Fragment>
    );
    return item;
  });

  const togglePkgModal = () => {
    setTagState({ showPkg: false, message: null });
  };

  return (
    <>
      {
        <div className={props.cssSidebar} style={props.styleSidebar}>
          <div className={"sidebar-sticky"}>
            <div className="tree-wrapper">
              {packages !== undefined && (
                <>
                  <div className="my-2  d-flex" style={{ flex: 10 }}>
                    <div
                      className="w-20 mr-auto pr-1"
                      style={{ flex: 8, position: "relative" }}
                    >
                      {/* <input onChange={(e) => handleSearchInput(e)}  id='tree-search' value={searchtag} type='text' placeholder='Search...' maxLength={27} className="tree-search-input"></input> */}
                      <span
                        className="tree-search-input-suffix"
                        aria-hidden="true"
                        style={{ position: "absolute" }}
                      >
                        {/* <img src={treeSearch} alt="search" width="auto" height="15"></img> */}
                      </span>
                    </div>
                    {/* <img
                      src={treeViewCollapse}
                      onClick={() => {
                        props.setShowCollapse(false);
                      }}
                      className="d-inline treeButton"
                      alt="tree-collapse"
                      style={{ cursor: "pointer" }}
                    ></img> */}

                  </div>
                  <div className="py-0 mx-10" style={{ display: 'flex' }}>
                    {packages}
                    <IconButton style={{ alignSelf: 'flex-start' }} onClick={() => props.setShowCollapse(false)} size='small' >
                      <FaAnglesLeft />
                    </IconButton>
                    {/*<AiOutlinePlusCircle alt="Add" className="d-inline align-top mr-2 my-1 mx-2 abtn" width="auto" height="35" title="Add Package" />
                                        {/*<input type="text" id='package' name='package' maxLength="60" placeholder="add package..." style={{ height: '20px', width: '70.2%' }} data-project={proj.project_id} onChange={(e) => handleChange(e)} onKeyDown={(e) => onKeyDown(e)} onBlur={(e) => onBlurPkg(e)} />*/}
                  </div>
                </>
              )}
            </div>
          </div>

          <Dialog
            size="sm"
            open={tagState.showPkg}
            className="create-project tags-modal muiForm-Modal"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle
              className="model-title"
              id="draggable-dialog-title"
              toggle={togglePkgModal}
            >
              <div className="d-flex">
                <div> {t('Warning')} </div>
                <div
                  className="ml-auto close-MUIModal"
                  onClick={() => {
                    setTagState(false);
                  }}
                >
                  <MdClose />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="pb-3"> {tagState.message} </div>
            </DialogContent>
          </Dialog>
        </div>
      }
    </>
  );
};

export default React.memo(ConfigDetTagTree);
